import React from "react";
import heroPng from "../../../../assets/img/landings/a2b/mobile.png";
import { ReactComponent as HeroSvg } from "../../../../assets/img/landings/a2b/hero.svg";

const HeroChild = ({ width = "", height = "" }) => {
  return (
    <>
      <img width={width} height={height} src={heroPng} alt="Phones" />
      <HeroSvg />
    </>
  );
};

export default HeroChild;
